
export const determineMethodType = (currentGateway) => {
    const {payment_method_type:method, processor_type:processor} = currentGateway;
    if((method === "cc" || method === "pci_cc") && processor === "pp") return "card-method";
    if(method === "ewallet" && (processor === "apm" || processor === "manual")) return "ewalet-method";
    if(processor === "custom") return "custom-method";
    if(processor === 'manual_bank_wire') return "mbw-method";
    else return null;
};